module.exports = __webpack_public_path__ + "static/google-play-965cb77cd616df9e487f3007aa23cb00.png";